
export default function ListMenu({ userType }) {
 
  const columns = [
    ...(userType === 1 ? [{ key: "super_username", label: "SUPER",className: "menuUsername" }] : []),
    ...(userType === 1 || userType === 2
      ? [{ key: "master_username", label: "MASTER",className: "menuUsername" }]
      : []),
    ...(userType === 1 ||
    userType === 2 ||
    userType === 3 ||
    userType === 5 ||
    userType === 6
      ? [{ key: "username", label: "USER",className: "menuUsername" }]
      : []),
    { key: "id", label: "ID", className: "menuUsername" },
    { key: "amount", label: "AMOUNT", className: "menuUsername" },
    { key: "upi", label: "UPI", className: "menuUsername small" },
    { key: "acc_no", label: "ACC-NO", className: "menuUsername small" },
    { key: "acc_name", label: "ACC-NAME", className: "menuUsername small" },
    { key: "ifsc", label: "IFSC", className: "menuUsername small" },
    { key: "acc_type", label: "ACC-TYPE", className: "menuUsername small" },
    { key: "bank_name", label: "BANK-NAME", className: "menuUsername small" },
    { key: "msg", label: "MSG", className: "menuUsername" },
    { key: "date", label: "DATE", className: "menuUsername" },
    { key: "other", label: "OTHER", className: "menuUsername" },
    { key: "status", label: "STATUS", className: "menuUsername addFlex" },
  ];

  return (
    <div className="menuContainer primary white">
      {columns.map(({ key, label, className = "menuExchange" }) => (
        <div
          key={key}
          className={`${className} ${userType === 1 || userType === 2 ? "small" : null}`}
          style={{ cursor: "pointer" }}
        >
          {label}
        </div>
      ))}
    </div>
  );
}
